// extracted by mini-css-extract-plugin
module.exports = {"giftCardPaymentLabel":"GiftCardPaymentLabel__giftCardPaymentLabel___-re-t"};